import React from "react";
import PropTypes from "prop-types";

export default function YouTubeToS({ label }){
	return (
		<footer className="youtube-tos">
			By clicking &lsquo;{label}&rsquo; you certify that the content you are uploading complies with the YouTube Terms of Service (including the YouTube Community Guidelines) at <a href="https://www.youtube.com/t/terms" target="_blank">https://www.youtube.com/t/terms</a>. Please be sure not to violate others&rsquo; copyright or privacy rights.
		</footer>
	);
}

YouTubeToS.displayName = "YouTubeToS";
YouTubeToS.defaultProps = {
	label:"Approve Creative",
};

YouTubeToS.propTypes = {
	label:PropTypes.oneOf(["Approve Creative", "Submit"]),
};
